import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IAdministrativeComplaintView } from 'app/models/mainMenu/mainMenu';
import { IComplaintSearchViewModel } from 'app/models/search/search';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({providedIn: 'root'})
export class SearchService {
  public api: string = environment.privateApi + 'Search/';

  private http = inject(HttpClient);

  getSearchData(searchParam: IComplaintSearchViewModel): Observable<IAdministrativeComplaintView[]>{
    return this.http.post<IAdministrativeComplaintView[]>(this.api + 'getSearchData' , searchParam);
  }

}
